import React, { useEffect, useState } from "react"
import types from "prop-types"
import { isEmpty } from "lodash-es"
import { questionShape, sectionShape, userOptionShape } from "utils/propTypeShapes"
import AnsweredFormOverviewContext from "../AnsweredFormOverviewContext"

const usersMapById = (users) => users.reduce((map, user) => {
  map[user.id] = user

  return map
}, {})

const AnsweredFormOverviewContextProvider = ({
  answers,
  children,
  deletedQuestionsNote,
  deletedQuestions,
  newQuestionUuids,
  sections,
  users,
}) => {
  const [usersMap, setUsersMap] = useState({})

  useEffect(
    () => setUsersMap(usersMapById(users)),
    [users],
  )

  const answer = (questionUuid) => answers[questionUuid]

  const answeredDeletedQuestions = deletedQuestions.filter((deletedQuestion) => answers[deletedQuestion.uuid])

  const isNewQuestion = (questionUuid) => newQuestionUuids.includes(questionUuid)

  const userWithId = (userId) => usersMap[userId]

  const usersWithIds = (userIds) => (
    isEmpty(usersMap)
      ? []
      : userIds.map((userId) => userWithId(userId))
  )

  // Object exposed to context consumers
  const contextConsumerValue = {
    answer,
    answeredDeletedQuestions,
    answers,
    deletedQuestionsNote,
    isNewQuestion,
    sections,
    usersWithIds,
  }

  return (
    <AnsweredFormOverviewContext.Provider value={contextConsumerValue}>
      {children}
    </AnsweredFormOverviewContext.Provider>
  )
}

AnsweredFormOverviewContextProvider.propTypes = {
  answers: types.object.isRequired,
  children: types.node.isRequired,
  deletedQuestionsNote: types.string.isRequired,
  deletedQuestions: types.arrayOf(questionShape).isRequired,
  newQuestionUuids: types.arrayOf(types.string).isRequired,
  sections: types.arrayOf(sectionShape).isRequired,
  users: types.arrayOf(userOptionShape).isRequired,
}

export default AnsweredFormOverviewContextProvider
